import { WebContentProps } from './WebContent.shared';

//Fix: ReactNative WebView not rendering on web
//see: https://stackoverflow.com/questions/60592332/reactnative-webview-not-rendering-on-web-but-works-fine-on-android

export const WebContent = ({ source }: WebContentProps) => {
  return (
    <iframe
      //@ts-ignore
      src={source?.uri}
      height={'100%'}
      width={'100%'}
      //@ts-ignore
      srcDoc={source?.html}
    />
  );
};
